import React from 'react';
import { Icon, IconProps } from 'semantic-ui-react';
import { UserStatusEnum } from '../../../../enums/user-status.enum';
import { translateUserStatus } from '../../../../util';
import { StatusBadgeWrapper } from './styles';

type StatusBadgeProps = {
  status: string;
};

type BadgeVariant = 'active' | 'pending' | 'inactive' | 'default';

const getBadgeVariant = (status: string): BadgeVariant => {
  switch (status) {
    case UserStatusEnum.active:
      return 'active';
    case UserStatusEnum.pending:
      return 'pending';
    case UserStatusEnum.inactive:
      return 'inactive';
    default:
      return 'default';
  }
};

const BADGE_ICONS: Record<BadgeVariant, IconProps['name']> = {
  active: 'check circle',
  pending: 'clock outline',
  inactive: 'ban',
  default: 'question circle outline'
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const variant = getBadgeVariant(status);
  const label = translateUserStatus(status);

  return (
    <StatusBadgeWrapper $variant={variant} role="status" aria-label={`Status: ${label}`}>
      <Icon name={BADGE_ICONS[variant]} aria-hidden="true" />
      {label}
    </StatusBadgeWrapper>
  );
};

export default StatusBadge;
